import { useMediaQuery } from '@mui/material'

export const useIsMobile = () => {
  const isMobile =
    useMediaQuery(`@media (max-width: 600px) and (orientation: portrait),
         (max-width: 1000px) and (orientation: landscape)`)

  return isMobile
}
